export const policeReportFunctions = {
    getInsuranceField: (insurance, field) => {
        if (field.includes('.')) {
            return field.split('.').reduce((acc, curr) => acc[curr], insurance)
        } else {
            return insurance[field]
        }
    },
    getReportField: (itemData, field) => {
        if (itemData && field) {
            if (field && field.includes('.')) {
                if (itemData[field.split('.')[0]]) {
                    return field.split('.').reduce((acc, curr) => acc[curr], itemData)
                } else {
                    return null
                }

            } else {
                return itemData[field]
            }
        }
    },
    isMatchInsurance: (policeReportInsurance, caseInsurances) => {
        if (policeReportInsurance && caseInsurances) {

            const match = caseInsurances.find(caseInsurance => (
                policeReportInsurance.insurance_carrier_id == caseInsurance.id ||
                policeReportInsurance.carrier_name == caseInsurance.insurance_carrier.name ||
                policeReportInsurance.policy_number == caseInsurance.policy_number
            ));
            if (match) {
                return match;
            }
        }
        return false
    },
    isMoonbirdReportProcessed(activeCase) {
        const value =
            activeCase?.police_report?.is_moonbird_report_processed ??
            activeCase?.case_police_report?.is_moonbird_report_processed
        return Number(value) === 1
    },
}

